import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-close-circle',
  templateUrl: './icon-close-circle.component.html',
  styleUrls: ['./icon-close-circle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconCloseCircleComponent {}
